<template>
  <v-container>
    <v-row justify="center">
      <v-col md="6" sm="8" xs="12">
        <v-card>
          <v-toolbar color="green darken-2">
            <v-toolbar-title class="white--text">Cash Transfer</v-toolbar-title>
            <v-spacer></v-spacer>
            <AccounCreate
              :Display="LoadAccounts"
              :AccountType="AccountType"
            ></AccounCreate>
          </v-toolbar>
          <v-card-text>
            <!-- {{ expense }} -->
            <v-form ref="TransferForm">
              <v-row justify="center">
                <v-col cols="9">
                  <v-select
                    v-model.trim="amountType"
                    :items="GetCashTypes"
                    :rules="[v => !!v || 'Cash Type is required']"
                    label="Cash Type"
                    required
                    no-data-text="Refresh the page"
                  ></v-select>
                </v-col>
                <v-col cols="9" md="5">
                  <v-select
                    return-object
                    :rules="[SameAccount, Amountypecheking]"
                    :loading="selected"
                    :disabled="selected"
                    v-model="Transfer.FromAccount"
                    :items="CashAccounts"
                    label="From Account"
                    @change="Onselect"
                  ></v-select>
                </v-col>
                <v-col cols="9" md="4">
                  <p class="font-weight-black text-center black--text mt-md-5">
                    {{ AvBalance.toLocaleString() }}
                    {{ this.amountType | MoneySigns }}
                  </p>
                </v-col>
                <v-col cols="9" md="5">
                  <v-text-field
                    :readonly="AvBalance > 0 ? false : true"
                    :rules="[v => !!v || 'Amount is require', AmountCheking]"
                    name="TranFerAmount"
                    label="Transfer Amount"
                    id="TransferAmounID"
                    type="number"
                    v-model.number="Transfer.Amount"
                  ></v-text-field>
                </v-col>
                <v-col cols="8" md="4">
                  <p
                    v-if="Transfer.Amount"
                    class="font-weight-black text-center black--text mt-md-5"
                  >
                    {{ Transfer.Amount.toLocaleString() }}
                    {{ this.amountType | MoneySigns }}
                  </p>
                </v-col>

                <v-col cols="9">
                  <v-select
                    return-object
                    :rules="[SameAccount]"
                    v-model="Transfer.ToAccount"
                    :items="CashAccounts"
                    label="To Account"
                  ></v-select>
                </v-col>

                <v-col cols="8">
                  <v-btn
                    :loading="clicked"
                    @click="OnTranser"
                    color="success"
                    block
                    >Transfer</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AccounCreate from "@/components/NewAccount";
import { mapGetters } from "vuex";
// import axios from "axios";
export default {
  components: { AccounCreate },
  data() {
    return {
      amountType: "",
      selected: false,
      clicked: false,
      AccountType: "Cash",
      CashAccounts: [],
      AvBalance: 0,
      Transfer: {
        FromAccount: "",
        Amount: null,
        ToAccount: "",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    Amountypecheking(v) {
      // console.log(this.amountType);
      return !!v || "Amount type is required";
      // if (this.amountType) return false;
      // else return "Amount type is required";
    },
    OnTranser() {
      if (this.$refs.TransferForm.validate()) {
        this.clicked = true;
        this.Transfer.AmountType = this.amountType;
        this.Transfer.date = this.Current().date;
        this.Transfer.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/qarash/transfer",
            data: { transfer: this.Transfer },
          })
          .then(() => {
            this.clicked = false;
            this.$refs.TransferForm.reset();
            this.AvBalance = 0;
          })
          .catch(() => {
            // console.log(error.response);
            this.clicked = false;
          });
      }
    },
    AmountCheking(v) {
      // if (v > this.AvBalance || Number(v) == 0 || isNaN(Number(v)))
      //   return "invalid Amount";
      // else return false;

      return v <= this.AvBalance || "Invalid Amount";
    },
    SameAccount(val) {
      if (!val) return "This is Required";
      else if (this.Transfer.FromAccount === this.Transfer.ToAccount)
        return "Accounts must be defferent";
      else return true;
    },
    Onselect(val) {
      this.AvBalance = 0;
      if (this.amountType) {
        this.selected = true;
        this.ShowBittyCash(val.text)
          .then(result => {
            // console.log(result);
            this.selected = false;
            if (result.data.length > 0) this.AvBalance = result.data[0].Amount;
            else this.AvBalance = 0;
          })
          .catch(() => {
            // console.log(error);
            this.selected = false;
          });
      }
    },

    GetReg(name) {
      return this.$store.dispatch("FIND_BY_VALUE_ONLY", {
        url: "/qarash/Accounts",
        ID: name,
      });
    },
    ShowBittyCash(AccName) {
      //   console.log(AccName);
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/qarash/totalcash",
        data: { Account: AccName, cashType: this.amountType },
      });
    },
    LoadAccounts() {
      this.GetReg(this.AccountType).then(result => {
        // console.log(result[2]);
        this.Cashes = result.data;

        //All CashAccounts Account
        result.data.forEach(element => {
          this.CashAccounts.push({
            text: element.AccountName,
            value: element._id,
          });
        });
      });
    },
  },

  created() {
    this.LoadAccounts();
  },
};
</script>
